module.exports = __webpack_public_path__ + "media/staff/worship-study-edited-5adfe2ea.jpg";